"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invariant;

function invariant(condition, message) {
  var booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message || 'Unexpected invariant triggered');
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/invariant.js
// module id = 33
// module chunks = 0